import { applicationFormToMutation as formToMutation } from './applicationFormToMutation';
import { applicationSettingsQueryToForm as queryToForm } from './applicationQueryToForm';

export default { queryToForm, formToMutation };